import { gql } from '@apollo/client';

import { mediaListItemFragment } from '../fragments';

export default gql`
  mutation DeleteMediaItem(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
  ) {
    mediaItem(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
    )
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}"
        method: "DELETE"
      ) {
      ...MediaListItem
    }
  }
  ${mediaListItemFragment}
`;
